export default "__VITE_ASSET__7fb93df5__"